import { MenuProps } from '@mui/material';
import { ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { AccountMenuDesktop } from './account-menu-desktop';
import { AccountMenuMobile } from './account-menu-mobile';

type AccountMenuProps = MenuProps;

export const AccountMenu = (props: AccountMenuProps): ReactElement => {
    const { open, onClose, ...menuProps } = props;
    const isMobile = useIsMobile();

    return isMobile ? (
        <AccountMenuMobile open={open} onClose={onClose} />
    ) : (
        <AccountMenuDesktop {...menuProps} open={open} onClose={onClose} />
    );
};
